import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"

import paths from "utils/paths"
import getMediaUrl from "utils/getMediaUrl"
import H from "components/atoms/H"
import P from "components/atoms/P"

import {
  blockHeadingStyles,
  blockTextStyles,
  StyledListBlock,
  StyledBlockImage,
  linkButtonStyles,
} from "./ArticleCard.styles"

const ArticleCard = ({
  article: { image, articleTitle, cardTeaser, slug },
}) => {
  const { formatMessage } = useIntl()

  return (
    <StyledListBlock>
      <StyledBlockImage loading="lazy" src={getMediaUrl(image)} />
      <H as="h4" extraStyles={blockHeadingStyles}>
        {articleTitle}
      </H>
      <P extraStyles={blockTextStyles}>{cardTeaser}</P>
      <P
        extraStyles={linkButtonStyles}
        to={`${paths.article(slug)}`}
        data-testid="articleLink"
      >
        {formatMessage({
          id: "readMore",
        })}
      </P>
    </StyledListBlock>
  )
}

ArticleCard.propTypes = {
  article: PropTypes.shape({
    articleTitle: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.oneOfType([
      PropTypes.shape({
        original: PropTypes.string,
        large: PropTypes.string,
        medium: PropTypes.string,
        small: PropTypes.string,
      }),
      PropTypes.string,
    ]),
    cardTeaser: PropTypes.string,
  }).isRequired,
}

export default ArticleCard
